import { AxiosError } from 'axios';
import { ElNotification } from 'element-plus';
import { useMediaQuery } from '@vueuse/core';

export const useHelpers = () => {
  // Maneja el mensaje de error activando la alerta
  function errorHandler(err: any) {
    if (err instanceof AxiosError) {
      if (err.code == 'ERR_NETWORK') {
        ElNotification({
          title: 'Error',
          message: 'Connection error',
          type: 'error',
        });
      } else {
        const response = err.response;
        if (response) {
          const msg = response.data?.message;
          let msgFormat = ``;

          if (msg === 'Validation failed' && response.data.validationErrors) {
            // Manejar errores de validación específicos
            response.data.validationErrors.forEach((error: any) => {
              if (error.message && Array.isArray(error.message)) {
                error.message.forEach((message: string) => {
                  msgFormat += `<p>• ${message}</p>`;
                });
              } else if (error.message) {
                msgFormat += `<p>• ${error.message}</p>`;
              }
            });
          } else if (response.data.errors) {
            // Manejar errores de validación con estructura diferente
            response.data.errors.forEach((error: any) => {
              if (error.message && Array.isArray(error.message)) {
                error.message.forEach((message: string) => {
                  msgFormat += `<p>• ${message}</p>`;
                });
              } else if (error.message) {
                msgFormat += `<p>• ${error.message}</p>`;
              }
            });
          } else if (msg !== 'Datos invalidos') {
            msgFormat = msg;
          }

          ElNotification({
            title: 'Error de Validación',
            message: msgFormat || 'Error desconocido',
            type: 'error',
            dangerouslyUseHTMLString: true,
          });
        } else {
          ElNotification({
            title: 'Error',
            message: `Error desconocido: ${err.message}`,
            type: 'error',
          });
        }
      }
    } else {
      ElNotification({
        title: 'Error',
        message: `Error desconocido: ${err.message}`,
        type: 'error',
      });
    }
  }

  const isMobile = useMediaQuery('(max-width: 768px)');

  /**
   * Convierte el valor de un input `datetime-local` (sin zona horaria) a ISO UTC.
   * El texto se interpreta en la zona horaria del navegador, que es la del usuario;
   * si se enviara tal cual, el servidor lo interpretaría en su propia zona horaria.
   */
  function datetimeLocalToISO(value: string): string {
    return new Date(value).toISOString();
  }

  return {
    errorHandler,
    isMobile,
    datetimeLocalToISO,
  };
};
